import { MenuItem, TextField, Box } from "@mui/material";
import { FIELD_COMPARISON_OPERATORS, OPERATORS_BY_TYPE } from "./utils/operators.config";
import SysColumn from "app/class/sys-column";
import Translate from "component/global/translation/translation-component";

interface OperatorSelectorProps {
    column?: SysColumn;
    value: string;
    onChange: (operator: string) => void;
    includeFieldOperators?: boolean;
    labelFor?: (label: string) => string | undefined;
    ariaLabel?: string;
    placeholder?: string;
    allowedOperators?: string[];
}

export const OperatorSelector = ({ 
    column, 
    value, 
    onChange,
    includeFieldOperators = false,
    labelFor,
    ariaLabel,
    placeholder,
    allowedOperators,
}: OperatorSelectorProps) => {
    if (!column) {
        return (
            <TextField size="small" sx={{ minWidth: 140, width: "100%" }} inputProps={{ "aria-label": ariaLabel }} placeholder={placeholder} disabled value="" />
        );
    }

    const colType = column ? column.column_type || "TEXT" : "TEXT";
    const operators = [
        ...(OPERATORS_BY_TYPE[colType] || []),
        ...(includeFieldOperators ? FIELD_COMPARISON_OPERATORS : []),
    ].filter((op) => (!op.value.startsWith("in_table_chain") && !op.value.startsWith("in_ancestor_chain") || column.referenced_table_name === "sys_tables") && (!allowedOperators || allowedOperators.includes(op.value)));

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            <TextField
                select
                size="small"
                value={value || ""}
                inputProps={{ "aria-label": ariaLabel }}
                SelectProps={placeholder ? { displayEmpty: true } : undefined}
                onChange={(e) => onChange(e.target.value)}
                sx={{ minWidth: 140, width: "100%" }}
            >
                <MenuItem value="">
                    <em>{placeholder || <Translate text="Select operator" />}</em>
                </MenuItem>
                {operators.map((op) => (
                    <MenuItem key={op.value} value={op.value}>
                        {labelFor?.(op.label) || <Translate text={op.label} />}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
};
